import { render, staticRenderFns } from "./SeparationAnxietyExerciseCard.vue?vue&type=template&id=4b11ecf4&"
import script from "./SeparationAnxietyExerciseCard.vue?vue&type=script&lang=js&"
export * from "./SeparationAnxietyExerciseCard.vue?vue&type=script&lang=js&"
import style0 from "./SeparationAnxietyExerciseCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports